import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { TcsmStates } from '../../root/tcsm-model';
import { useSearchList } from '../hooks/useSearchList';
import { BackendSearchState, SearchAppContext } from '../models/search-models';
import { WysiwygWithReactLink } from '../../global/components/wysiwyg-with-react-link';

interface Props {
	renderItem: (item: any) => JSX.Element;
	updateList: (searchState: BackendSearchState) => void;
	emptyResultMessage?: string;
}

export function BackendSearchList(props: Props) {
	const app = useContext(SearchAppContext);
	const list = useSelector<TcsmStates, any[]>(state => state?.backendSearchStates[app]?.list);
	const requesting = useSelector<TcsmStates, boolean>(state => state?.backendSearchStates[app]?.requesting);
	useSearchList(props.updateList);

	if (requesting) {
		return <LoadingCircle />;
	}

	if (list?.length === 0) {
		return <WysiwygWithReactLink content={props?.emptyResultMessage} />;
	}

	return (
		<>
			{
				list?.map(item => props?.renderItem(item))
			}
		</>

	);
}

BackendSearchList.defaultProps = {
	emptyResultMessage: '',
};
